import React from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";

const PrivateRoute = ({ component: Component, authUserData, restrictedPssTypes, ...rest }) => {
  const isLoggedIn = authUserData?.isAuth;
  const userPssType = authUserData?.prestador?.tipoPss;

  const hasAccess = isLoggedIn && (
    !restrictedPssTypes || 
    !restrictedPssTypes.includes(userPssType)
  );

  return (
    <Route
      {...rest}
      render={(props) =>
        hasAccess ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: isLoggedIn ? "/dashboard" : "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(PrivateRoute);